export const updateProperties = [
  {
    bulkType: 'CATEGORY_TYPE',
    field: 'cannabis',
    name: 'Category Type',
    bulkOption: true,
    action: 'CATEGORY_TYPE',
  },
  {
    bulkType: 'MEASUREMENT',
    field: 'unitType',
    name: 'Measurement',
    bulkOption: true,
    action: 'MEASUREMENT',
  },
  {
    bulkType: 'LOW_INVENTORY_THRESHOLD',
    field: 'lowThreshold',
    name: 'LIT',
    bulkOption: true,
    action: 'LOW_INVENTORY_THRESHOLD',
  },
  {
    bulkType: 'ARCHIVE_STATUS',
    field: 'archived',
    name: 'Archived',
    bulkOption: true,
    action: 'ARCHIVE_STATUS',
  },
  {
    bulkType: 'PHOTO',
    field: 'image',
    name: 'Image',
  },
  {
    bulkType: 'TOP_LEVEL_CATEGORY',
    field: 'topLevelCategory',
    name: 'Top Level Category',
  },
  {
    bulkType: 'CANNABIS_TYPE',
    field: 'cannabisType',
    name: 'Cannabis Type',
  },
  {
    bulkType: 'COMPLIANCE_ID',
    field: 'complianceCategoryId',
    name: 'Compliance Category',
  },
]



// WEBPACK FOOTER //
// ./src/utils/catalog/masterCategory.js